import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#FD8112',
      light: '#FFA954',
      dark: '#C85E00',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#12121C',
      light: '#2A2A3D',
      dark: '#050508',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#F8F8FB',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#14141F',
      secondary: '#5B5B6E',
    },
  },
  shape: {
    borderRadius: 16,
  },
  typography: {
    fontFamily: "'Nunito', sans-serif",
    h1: { fontFamily: "'Poppins', sans-serif", fontWeight: 700 },
    h2: { fontFamily: "'Poppins', sans-serif", fontWeight: 700 },
    h3: { fontFamily: "'Poppins', sans-serif", fontWeight: 600 },
    h4: { fontFamily: "'Poppins', sans-serif", fontWeight: 600 },
    h5: { fontFamily: "'Poppins', sans-serif", fontWeight: 600 },
    h6: { fontFamily: "'Poppins', sans-serif", fontWeight: 600 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          textTransform: 'none',
          fontWeight: 600,
          paddingLeft: 24,
          paddingRight: 24,
          boxShadow: 'none',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 20,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 20,
        },
      },
    },
  },
});

export default theme;
